import React, { Component } from 'react';
import axios from "axios";
import moment from 'moment';

import ParadigmaTable from "../../../../components/ParadigmaTable/"
import api from '../../../../api/';

import Modal from "./Modal.js"

moment.lang('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
  weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
  weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
});

import './styles.css';


class Pedidos extends Component {
  constructor() {
    super();

    this.state = {
      columns: [
        {
          Header: "id",
          id: "id",
          accessor: "id",
          show: false,
          private: true,
        },
        {
          Header: "Fecha",
          style:{textAlign:'center'},
          id:"Fecha",
          width: 140,
          Cell: d => moment(d.original.Fecha).format("DD-MM-YYYY HH:mm")
        },
        {
          Header: "Número",
          style:{textAlign:'center'},
          id:"Numero",
          width: 140,
          accessor: "Numero",
        },
        {
          Header: "Nombre / Razón Social",
          accessor: "CompradorNombre",
          id: "CompradorNombre",
        },
        {
          Header: "Documento",
          accessor: "CompradorDocumento",
          id: "CompradorDocumento",
          className:"text-left",
          Cell: d=>(<div className="pedido-documento">{d.original.CompradorDocumento}</div>),
          width: 160,
        },
        {
          Header: "Estado",
          id:"Estado",
          accessor:"Estado",
          width: 140,
          Cell: d => {
            let result = (<div className="text-center pedido-state pedido-state-pendiente">PENDIENTE</div>);
            switch (d.original.Estado.toLowerCase()) {
              case "pe":
              result = (<div className="text-center pedido-state pedido-state-pendiente">PENDIENTE</div>);
              break;
              case "pp":
              result = (<div className="text-center pedido-state pedido-state-pendiente">PENDIENTE YA PAGO</div>);
              break;
              case "ca":
              result = (<div className="text-center pedido-state pedido-state-cancelado">CANCELADO</div>);
              break;
              case "pr":
              result = (<div className="text-center pedido-state pedido-state-pendiente">PARA SER FACTURADO</div>);
              break;
              case "fa":
              result = (<div className="text-center pedido-state pedido-state-confirmado">FACTURADO</div>);
              break;
              case "co":
              result = (<div className="text-center pedido-state pedido-state-confirmado">CONFIRMADO</div>);
              break;
              default:
              result = (<div className="text-center pedido-state pedido-state-pendiente">PENDIENTE</div>);
            }
            return result;
          },
          filterable: true,
          lookup:"exact",
          Filter: ({ filter, onChange }) =>(
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"FA"}>FACTURADOS</option>
              <option value={"PR"}>PARA SER FACTURADOS</option>
              <option value={"CO"}>CONFIRMADOS</option>
              <option value={"PE"}>PENDIENTES</option>
              <option value={"PP"}>PENDIENTES YA PAGO</option>
              <option value={"CA"}>CANCELADOS</option>
            </select>
          ),
        },
        {
          Header: "Importe Total",
          id:"Total",
          accessor:"Total",
          width: 100,
          className:"text-right",
          Cell: d => d.original.Total == undefined || d.original.Total == null || d.original.Total == "" ? "$ 0.00" : `$ ${String(d.original.Total.toFixed(2))}`
        },
      ]
    };
  }

  render() {
    const { data, pages, loading } = this.state;
    const { modernTheme } = this.props;
    return (
      <ParadigmaTable
        modernTheme={modernTheme}
        refreshAutomatico={true}
        refreshAutomaticoBtn={true}
        refreshAutomaticoBtnTimer={90}
        buttons={[
          {
            edit: true,
            permission: 'ecommerce_ventas_pedidos_edit',
            component: (props) => <Modal {...props} action="CONFIRMAR" />,
          },
          {
            edit: true,
            permission: 'ecommerce_ventas_pedidos_edit',
            component: (props) => <Modal {...props} action="CANCELAR" />,
          },
          {
            edit: true,
            permission: 'ecommerce_ventas_pedidos_edit',
            component: (props) => <Modal {...props} action="PENDIENTE" />,
          },
          {
            edit: true,
            component: (props) => <Modal {...props} action="DETAIL" />,
            permission: 'ecommerce_ventas_pedidos_detail',
          },
        ]}
        apiUrl={api.gestion.ventas.pedidos}
        columns={this.state.columns}
        title={"Pedidos"}
      />
    );
  }
}

export default Pedidos;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Pedidos/Pedidos.js